import React, { useState, useEffect, useRef } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import UtilisationFloorPlanDoughnut from "./UtilisationFloorPlanDoughnut";
import UtilisationFloorPlanDateTimeTicker from "./UtilisationFloorPlanDateTimeTicker";
import {SYSTEM_BLUE_BACKGROUND_LIGHT} from "../../../constants/general-constants";
import { COLOR_GRAY_BANNER_BACKGROUND } from "../../../constants/general-constants";

am4core.useTheme(am4themes_animated);

export default function UtilisationFloorPlanChartPanel({}) {
  const deskDoughnutRef = useRef(null);
  const sensorDoughnutRef = useRef(null);
  const meetingRoomUtilisationRef = useRef(null);
  const meetingRoomOccupancyRef = useRef(null);

  // Static demo values for doughnuts
  const [overallUtilisation, setOverallUtilisation] = useState(50);
  const [deskUtilisation, setDeskUtilisation] = useState(30);
  const [sensorUtilisation, setSensorUtilisation] = useState(40);
  const [meetingRoomUtilisation, setMeetingRoomUtilisation] = useState(50);
  const [meetingRoomOccupancy, setMeetingRoomOccupancy] = useState(20);
  const [sensorDifference, setSensorDifference] = useState(6);
  const [sensorMismatches, setSensorMismatches] = useState(21);
  
  const doughnutContainer = {display:'flex', width:'50%', height:'20vh'};
  const sensorPanel = {borderRadius:'6px', display:'flex', minWidth:'100%', marginTop:'20px', flexWrap:'wrap', backgroundColor:SYSTEM_BLUE_BACKGROUND_LIGHT};
  const sensorLabel = {fontWeight:'bold', width:'100%', justifyContent:'space-around', display:'flex', fontSize:'14px', color:'white', alignSelf:'center', lineHeight:'40px'};
  const sensorMismatchPanel = {borderRadius:'6px', display:'flex', minWidth:'100%', marginTop:'20px', flexWrap:'wrap', backgroundColor:'darkred'};
  const sensorMismatchLabel = { width:'100%', justifyContent:'space-around', display:'flex', fontSize:'14px', color:'white', alignSelf:'center', lineHeight:'40px'};
  const sensorMismatchFigure = {fontWeight:'bold', width:'100%', justifyContent:'space-around', display:'flex', fontSize:'21px', color:'white', alignSelf:'center', lineHeight:'40px'};

  // Random fluctuation logic to simulate slight data changes
  const getRandomData = (value) => {
    const fluctuation = Math.random() * 2 - 1; // Range from -1 to +1
    return Math.max(0, Math.min(100, value + fluctuation)); // Ensure the value stays between 0 and 100
  };

  useEffect(() => {
  	//setOverallUtilisation(getRandomData(50));
  	//setDeskUtilisation(getRandomData(30));
    //setSensorUtilisation(getRandomData(40));
    //setMeetingRoomUtilisation(getRandomData(50));
    //setMeetingRoomOccupancy(getRandomData(20));
    //setSensorDifference(getRandomData(6));
    const interval = setInterval(() => {
    	setOverallUtilisation(getRandomData(50));
      setDeskUtilisation(getRandomData(30));
      setSensorUtilisation(getRandomData(40));
      setMeetingRoomUtilisation(getRandomData(50));
      setMeetingRoomOccupancy(getRandomData(20));
      setSensorDifference(getRandomData(6));
    }, 3000); // Update every second for demo purposes

    //return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);
  

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height:'100%', backgroundColor: "#fff", borderLeft:'2px solid ' + SYSTEM_BLUE_BACKGROUND_LIGHT }}>
      <UtilisationFloorPlanDateTimeTicker/>

      <div style={{ display: 'flex', flexWrap:'wrap', marginTop: '0px', padding: '0px' }}>
      	<div style={doughnutContainer}>
	       	<UtilisationFloorPlanDoughnut
	       		id="overallDoughnut"
	       		value={overallUtilisation}
	       		label="Overall Utilisation"
	       		isDarkBackground={false}
	       	/>
	       </div>
	       <div style={doughnutContainer}>
	       	<UtilisationFloorPlanDoughnut
	       		id="deskDoughnut"
	       		value={deskUtilisation}
	       		label="Desk Utilisation"
	       	/>
	       </div>
	       <div style={doughnutContainer}>
	       	<UtilisationFloorPlanDoughnut
	       		id="meetingDoughnut"
	       		value={meetingRoomUtilisation}
	       		label="Meeting Rooms"
	       	/>
	       </div>
	       <div style={doughnutContainer}>
	       	<UtilisationFloorPlanDoughnut
	       		id="ocupancyDoughnut"
	       		value={meetingRoomOccupancy}
	       		label="Occupancy"
	       	/>
	       </div>
	       <div style={sensorPanel}>
	       	<div style={sensorLabel}>
	       		Sensor Information
	       	</div>
	       
		       <div style={doughnutContainer}>
		       	<UtilisationFloorPlanDoughnut
		       		id="sensorDoughnut"
		       		value={sensorUtilisation}
		       		label="Utilisation"
		       		isDarkBackground={true}
		       	/>
		       </div>
		       <div style={doughnutContainer}>
		       	<UtilisationFloorPlanDoughnut
		       		id="differenceDoughnut"
		       		value={sensorDifference}
		       		label="Difference"
		       		isDarkBackground={true}
		       	/>
		       </div>
		       <div style={sensorMismatchPanel}>
		       	<div style={sensorMismatchLabel}>
		       		Number of Sensor Mismatches
		       	</div>
		       	<div style={sensorMismatchFigure}>
		       		{sensorMismatches}
		       	</div>
		       </div>
		     </div>
        {/*<div id="deskDoughnut" ref={deskDoughnutRef} style={{ width: '100%', height: '100px' }}></div>
        <div id="sensorDoughnut" ref={sensorDoughnutRef} style={{ width: '100%', height: '100px' }}></div>
        <div id="meetingRoomUtilisation" ref={meetingRoomUtilisationRef} style={{ width: '100%', height: '100px' }}></div>
      <div id="meetingRoomOccupancy" ref={meetingRoomOccupancyRef} style={{ width: '100%', height: '100px' }}></div>*/}
      </div>
    </div>
  );
}









